import { useEffect, useState } from "react";
import { useGetUsersQuery } from "./usersApiSlice";
import User from "./User";
import useTitle from "../../hooks/useTitle";
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate, Link, useLocation } from "react-router-dom";

import UserModal from "./UserModal";
import NewUserForm from "./NewUserForm";

const UsersList = () => {
  useTitle("Klijenti");

  const navigate = useNavigate();
  const [enabled, setEnabled] = useState(false);
  const [selectedValue, setSelectedValue] = useState("10");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedOption, setSelectedOption] = useState("svi");
  const [selectedValutaOption, setSelectedValutaOption] = useState("svi");

  const [searchTerm, setSearchTerm] = useState(""); // Držimo searchTerm za unos pretrage
  const [currentPage, setCurrentPage] = useState(1);

  const [showOnlyGoogleUsers, setShowOnlyGoogleUsers] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = () => {
    handleCloseModal();
  };

  const filterOptions = [
    { value: "svi", label: "Status" },
    { value: "Aktivan", label: "Aktivan" },
    { value: "Neaktivan", label: "Neaktivan" },
  ];

  const filterOptionsValuta = [
    { value: "svi", label: "Valuta" },
    { value: "RSD", label: "RSD" },
    { value: "EUR", label: "EUR" },
  ];

  const {
    data: users,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetUsersQuery("usersList", {
    pollingInterval: 60000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  // useEffect(() => {
  //   if (users) {
  //     console.log("users => ", users);
  //   }
  // }, [users]);

  let content;

  if (isLoading) content = <PulseLoader color={"#FFF"} />;

  if (isError) {
    content = <p className="errmsg">{error?.data?.message}</p>;
  }

  let tableContent = null;

  if (isSuccess) {
    const { ids, entities } = users;

    // console.log("users => ", users);

    const filteredIds = ids
      .slice()
      .reverse()
      .filter((id) => {
        const user = entities[id];

        const lowerSearch = searchTerm.toLowerCase().trim();

        const nazivPaketa = user.lastActivePackage?.naziv_paketa;

        const matchesStatus =
          selectedOption === "svi" || user.status === selectedOption;

        const matchesValuta =
          selectedValutaOption === "svi" ||
          user.valuta === selectedValutaOption;

        const matchesSearchTerm =
          user.name.toLowerCase().includes(lowerSearch) ||
          user.lastName.toLowerCase().includes(lowerSearch) ||
          user.pol.toLowerCase().includes(lowerSearch) ||
          user.mail.toLowerCase().includes(lowerSearch) ||
          nazivPaketa?.toLowerCase().includes(lowerSearch) ||
          user.usedCodes?.some((code) =>
            code.naziv?.toLowerCase().includes(lowerSearch)
          );

        const matchesGoogle =
          !showOnlyGoogleUsers || (showOnlyGoogleUsers && !!user.googleId);

        return (
          matchesStatus && matchesValuta && matchesSearchTerm && matchesGoogle
        );
      });

    const totalUsers = filteredIds.length;

    const usersPerPage =
      selectedValue === "Svi" ? totalUsers : parseInt(selectedValue);
    const totalPages =
      selectedValue === "Svi" ? 1 : Math.ceil(totalUsers / usersPerPage);

    const startIndex = (currentPage - 1) * usersPerPage;
    const currentUsers =
      selectedValue === "Svi"
        ? filteredIds
        : filteredIds.slice(startIndex, startIndex + usersPerPage);

    tableContent = currentUsers.length
      ? currentUsers.map((userId, index) => (
          <User key={userId} userId={userId} index={index} />
        ))
      : null;

    // Pagination controls
    const handlePageChange = (newPage) => {
      if (newPage < 1 || newPage > totalPages) return;
      setCurrentPage(newPage);
    };

    content = (
      <>
        <div className="pagination-info flex justify-between items-center ml-4">
          <p>
            Ukupno korisnika: {totalUsers} | Stranica {currentPage} od{" "}
            {totalPages}
          </p>
          <div className="flex justify-center space-x-2">
            {/* Prev Page Button */}
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 mx-1 border rounded-md bg-white disabled:opacity-50"
            >
              &lt; Prethodna
            </button>

            {/* Next Page Button */}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 mx-1 border rounded-md bg-white disabled:opacity-50"
            >
              Sledeća &gt;
            </button>
          </div>
        </div>
      </>
    );
  }

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setCurrentPage(1); // Reset to first page whenever page size is changed
  };

  return (
    <>
      <div className="">
        <header className="mb-3">
          <div className="">
            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
              Klijenti
            </h1>
          </div>
        </header>
        <hr className="border-t border-slate-950" />
        <main className="">
          <div className="">
            <div className="mt-3 sm:flex sm:items-center sm:justify-between">
              {selectedValue !== "Svi" && content}

              <div className="flex items-center space-x-4 ml-4">
                <select
                  value={selectedValue}
                  onChange={handleChange}
                  className="px-8 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="Svi">Svi</option>
                </select>
              </div>

              <label
                htmlFor="googleUsersOnly"
                className="flex items-center space-x-2 cursor-pointer select-none text-sm text-gray-700 ml-4"
              >
                <input
                  type="checkbox"
                  id="googleUsersOnly"
                  checked={showOnlyGoogleUsers}
                  onChange={(e) => setShowOnlyGoogleUsers(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <span>Samo Google korisnici</span>
              </label>

              <div className="ml-auto flex items-center space-x-2">
                <p className="text-gray-700">Pretrazi:</p>
                <input
                  id="pretraga"
                  name="pretraga"
                  type="text"
                  placeholder="Pretraga po imenu, prezimenu, email-u"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="block w-35 rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {/* <div className="mt-3 sm:flex sm:items-center">
              {selectedValue !== "Svi" && content}

              <div className="ml-4">
                <div className="flex items-center space-x-4">
                  <select
                    value={selectedValue}
                    onChange={handleChange}
                    className="px-8 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="Svi">Svi</option>
                  </select>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <p className="text-gray-700">Pretrazi:</p>
                <input
                  id="pretraga"
                  name="pretraga"
                  type="text"
                  placeholder="Pretraga po imenu, prezimenu, email-u"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="block w-35 rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div> */}

            <div className="mt-3 flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-100">
                        <tr>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Rb.
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Prijav.
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Ime
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Prezime
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Godine
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Kilaza
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Email
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Pol
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Komentar
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Registracija
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Paket
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Tip
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Datum
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Preostalo
                          </th>
                          <th
                            scope="col"
                            className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Kod
                          </th>
                          <th
                            scope="col"
                            className="border-b px-4 py-2 text-left text-sm font-semibold text-gray-900"
                          >
                            Kontrole
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white">{tableContent}</tbody>
                    </table>
                    {tableContent === null && (
                      <p className="text-center py-4">
                        Nema klijenata za prikaz ili izaberi manji broj po
                        strani!
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />
          </div>
        </main>
      </div>

      <UserModal isOpen={isModalOpen} onClose={handleCloseModal}>
        <NewUserForm onSubmit={handleFormSubmit} onClose={handleCloseModal} />
      </UserModal>
    </>
  );
};

export default UsersList;
